import React from 'react'
import { NavLink } from 'react-router-dom';
export default function Navbar(props) {

    

    function changeColorOver(e) {
        e.target.style.color = "#caa9e0"
    }
    function changeColorOut(e) {
        e.target.style.color = "white"
    }

    
    return (
        <>
            
            <nav className="navbar navbar-expand-lg navbar-dark bg-dark fixed-top">
                <NavLink onClick={props.handleClick} className="navbar-brand mx-3" href="/">Pankaj Kumar</NavLink>
                <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
                    <span className="navbar-toggler-icon"></span>
                </button>
                <div className="collapse navbar-collapse" id="navbarNav">
                    <ul className="navbar-nav mr-auto mt-2 mt-lg-0" >

                    </ul>


                    <ul className="navbar-nav" >
                        <li className="nav-item ml-auto">
                            <NavLink className="nav-link mx-3" target="_blank" style={{ color: 'white' }} 
                            to="https://www.linkedin.com/in/kankopb/"><i onMouseOut={changeColorOut} onMouseOver={changeColorOver} className="fa-brands fa-linkedin-in fa-beat-fade fa-xl"></i></NavLink>
                        </li>
                        <li className="nav-item ml-auto">
                            <NavLink className="nav-link mx-3" target="_blank" style={{ color: 'white' }}
                                to="https://github.com/kankopb"><i onMouseOut={changeColorOut} onMouseOver={changeColorOver} className="fa-brands fa-github fa-beat-fade fa-xl"></i></NavLink>
                        </li>

                        <li className="nav-item ml-auto">
                            <NavLink className="nav-link mx-3" target="_blank" style={{ color: 'white' }}
                                to="https://twitter.com/kankopb"><i onMouseOut={changeColorOut} onMouseOver={changeColorOver} className="fa-brands fa-twitter fa-beat-fade fa-xl"></i></NavLink>
                        </li>

                        <li className="nav-item ml-auto">
                            <NavLink className="nav-link mx-3" target="_blank" style={{ color: 'white' }}
                                to="https://instagram.com/kankopb"><i onMouseOut={changeColorOut} onMouseOver={changeColorOver} className="fa-brands fa-instagram fa-beat-fade fa-xl"></i></NavLink>
                        </li>

                        <li className="nav-item ml-auto">
                            <NavLink className="nav-link mx-3" target="_blank" style={{ color: 'white' }}
                                to="https://wa.me/+919853333170"><i onMouseOut={changeColorOut} onMouseOver={changeColorOver} className="fa-brands fa-whatsapp fa-beat-fade fa-xl"></i></NavLink>
                        </li>

                        <li className="nav-item ml-auto">
                            <NavLink className="nav-link mx-3" target="_blank" style={{ color: 'white' }}
                                to="https://t.me/kankopb"><i onMouseOut={changeColorOut} onMouseOver={changeColorOver} className="fa-brands fa-telegram fa-beat-fade fa-xl"></i></NavLink>
                        </li>

                        <li className="nav-item ml-auto">
                            <NavLink className="nav-link mx-3" target="_blank" style={{ color: 'white' }}
                                to="mailto:kankopb@gmail.com"><i onMouseOut={changeColorOut} onMouseOver={changeColorOver} className="fa-solid fa-envelope fa-xl"></i></NavLink>
                        </li>


                    </ul>
                </div>
            </nav>
        </>
    )
}
